"use client";
import { useLockScroll } from "./use-lock-scroll.mjs";
import { useState } from "react";
import { useFocusReturn, useId as useId$1, useWindowEvent } from "@mantine/hooks";
//#region packages/@mantine/core/src/components/ModalBase/use-modal.ts
function useModal({ id, transitionProps, opened, trapFocus, closeOnEscape, onClose, returnFocus }) {
	const _id = useId$1(id);
	const [titleMounted, setTitleMounted] = useState(false);
	const [bodyMounted, setBodyMounted] = useState(false);
	const shouldLockScroll = useLockScroll({
		opened,
		transitionDuration: typeof transitionProps?.duration === "number" ? transitionProps?.duration : 200
	});
	useWindowEvent("keydown", (event) => {
		if (event.key === "Escape" && closeOnEscape && !event.isComposing && opened) event.target?.getAttribute("data-mantine-stop-propagation") !== "true" && onClose();
	}, { capture: true });
	useFocusReturn({
		opened,
		shouldReturnFocus: trapFocus && returnFocus
	});
	return {
		_id,
		titleMounted,
		bodyMounted,
		shouldLockScroll,
		setTitleMounted,
		setBodyMounted
	};
}
//#endregion
export { useModal };

//# sourceMappingURL=use-modal.mjs.map